import React from 'react';
import { setColorsPanelAction } from 'containers/Configurator/actions/general';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/PanesPanel/types';
import { makeSelectIsVisibleColorsPanel } from 'containers/Configurator/selectors/general';
import PanesColorPicker from 'containers/PanesPanel/PanesColorPicker';
import useMedia from 'use-media';
import PanelSelection from 'components/PanelSelection';
import { deleteSelectionAction } from 'containers/Ribbon/ShelvesRibbon/actions';
import { ActivePanel } from '../../Configurator/constants/general';

// import styled from 'styled-components/macro';

interface StateProps {
  isVisible: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  isVisible: makeSelectIsVisibleColorsPanel(ActivePanel.panes),
});

const MobileColorsPanel = () => {
  const dispatch = useDispatch();
  const { isVisible } = useSelector(stateSelector);

  const isMobile = useMedia({ maxWidth: 1023 });

  if (!isMobile) return null;

  const hidePanel = () => {
    dispatch(setColorsPanelAction());
  };

  const remove = () => {
    dispatch(deleteSelectionAction());
    hidePanel();
  };

  return (
    <PanelSelection
      close={hidePanel}
      isVisible={isVisible}
      autoclose={false}
      remove={remove}
    >
      {/*<div className="flex justify-center my-1">{t('Pick a color')}</div>*/}
      <PanesColorPicker paintMode={false} />
    </PanelSelection>
  );
};

export default MobileColorsPanel;
